import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import * as yup from 'yup';
import { useFormatMessage } from 'hooks';
import { AVAILABLE_LOCALES } from 'utils/locales';

const schema = yup.object().shape({
  name: yup.string().required(),
  locale: yup.string().required(),
});

const CountryForm = ({ country, onSubmitHandler, loading }) => {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: { ...country },
    resolver: yupResolver(schema),
  });

  // Extract all useFormatMessage calls at top level
  const nameLabel = useFormatMessage('CountryForm.name');
  const nameRequired = useFormatMessage('CountryForm.nameRequired');
  const localeLabel = useFormatMessage('CountryForm.locale');
  const selectLocale = useFormatMessage('CountryForm.selectLocale');
  const localeRequired = useFormatMessage('CountryForm.localeRequired');
  const submitLabel = useFormatMessage('CountryForm.submit');

  const onSubmit = (data) => {
    onSubmitHandler(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="field">
        <label className="label" htmlFor="name">{nameLabel}</label>
        <div className="control">
          <input
            id="name"
            className={`input ${errors.name ? 'is-danger' : ''}`}
            type="text"
            ref={register}
            name="name"
          />
        </div>
        {errors.name && (
          <p className="help is-danger">
            {nameRequired}
          </p>
        )}
      </div>

      <div className="field">
        <label className="label" htmlFor="locale">{localeLabel}</label>
        <div className="control">
          <div className="select">
            <select id="locale" ref={register} name="locale">
              <option value="">{selectLocale}</option>
              {AVAILABLE_LOCALES.map((loc) => (
                <option key={loc.value} value={loc.value}>
                  {loc.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        {errors.locale && (
          <p className="help is-danger">
            {localeRequired}
          </p>
        )}
      </div>

      <hr />
      <div className="field">
        <div className="control">
          <button
            type="submit"
            className={`button is-primary ${loading && 'is-loading'}`}
          >
            {submitLabel}
          </button>
        </div>
      </div>
    </form>
  );
};

export default CountryForm;
